import utils = egr.wcf.utils;

import { Dict } from './Types';
import { parseQueryString } from './Url';

// Note: we could use the nodejs-types but there are some issues
// with divergent types for common functions (e.g: setTimeout)
declare var process: {
    env: Dict<string | undefined>;
};

const REACT_APP_PREFIX: string = 'REACT_APP_';

function getBuildVar(key: string, fallback: string): string;
function getBuildVar(key: string, fallback?: string): string | undefined;
function getBuildVar(key: string, fallback?: string): string | undefined {
    const value: string | undefined = process.env[REACT_APP_PREFIX + key];

    if (value !== undefined) {
        return value;
    }

    return fallback;
}

// Note: at the moment the value is only generated once and not updated
// with a "hashchange" because I am not sure if this makes sense or not.
const UrlVars: Dict = parseQueryString(window.location.hash.slice(1));

export function getEnvVar(key: string): string | undefined;
export function getEnvVar(key: string, fallback: string): string;
export function getEnvVar(key: string, fallback?: string): string | undefined {
    const value: string = UrlVars[key];

    if (value !== undefined) {
        return value;
    }

    return getBuildVar(key, fallback);
}

export function getEnvArray(key: string, delimiter: string = ','): Array<string> {
    let value: string | undefined = UrlVars[key];

    if (value === undefined) {
        value = getBuildVar(key, '');
    }

    return value.split(delimiter).map((v: string): string => v.trim()).filter(utils.string.isNotNullOrEmpty);
}

export function getEnvNumber(key: string): number | undefined;
export function getEnvNumber(key: string, fallback: number): number;
export function getEnvNumber(key: string, fallback?: number): number | undefined {
    const value: string | undefined = getEnvVar(key);
    if (value === undefined) {
        return fallback;
    }

    return parseInt(value, 10);
}

export const developmentMode: boolean = process.env.NODE_ENV === 'development';

if (developmentMode) {
    (window as {_env_vars_?: {}})._env_vars_ = process.env;
}

// Only for debug purpose
export const allEnvVars: Dict<string | undefined> = {};
const prefixLength: number = REACT_APP_PREFIX.length;
Object.keys(process.env).filter(
    (v: string): boolean => v.startsWith(REACT_APP_PREFIX)
).map(
    (v: string) => v.substr(prefixLength)
).forEach((v: string): void => {
    allEnvVars[v] = getEnvVar(v, undefined!);
});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/utils/ReactScriptHelper.ts